import { JsonObject, JsonProperty } from 'json2typescript';
import { Pagination } from '../shared/pagination-model';

@JsonObject('StockLocationFilters')
export class StockLocationFilters extends Pagination {
  @JsonProperty('code', String, true) code: string = undefined;
}
